import React from "react"
import styled from "styled-components"
import {Body, Label, H3} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedCurrency, FormattedNumber} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {useBudgetsPermissions, useBudgetsList} from "@irati/wallet/hooks/budget"
import {useTheme} from "@irati/ui/src/global/useTheme"
import BudgetBar from "../../components/Budgeting/BudgetBar"
import ColorIcon from "../../components/Budgeting/ColorIcon"
import {useBudgetManagement} from "./hooks"
import {Unassigned} from "./shared/Unassigned"
import {Row, Item} from "./EditDashboard/EditableRow"

const StyledLabel = styled(Label)`
  font-size: 10px;
  line-height: 12px;
`

export default function Dashboard() {
  const {isBudgetAdmin} = useBudgetsPermissions()
  const {data} = useBudgetsList()
  const {dispatch} = useBudgetManagement()

  if (!data) return null

  const {total} = data

  return (
    <>
      <BudgetBar />
      <BudgetsView />
      <Flex>
        <Button small onClick={() => dispatch({type: "startEdit"})}>
          {isBudgetAdmin ? (
            <FormattedMessage id="wallet.reward.budget.dashboard.footer.cta.edit.admin" />
          ) : (
            <FormattedMessage id="wallet.reward.budget.dashboard.cta.edit.manager" />
          )}
        </Button>
      </Flex>

      <H3 as="span">
        <Flex as="span" justifyContent="space-between" marginRight={3}>
          <FormattedMessage id="wallet.reward.budget.dashboard.body.total" />
          <FormattedCurrency value={total} currency={"RP"} />
        </Flex>
      </H3>
    </>
  )
}

function BudgetsView() {
  const {data} = useBudgetsList()
  const {colors} = useTheme()

  if (!data) return null

  const {
    budgets: {unassigned, categories}
  } = data

  return (
    <Flex direction="column" flex="1" gap={2}>
      <Unassigned unassigned={unassigned} />

      {categories.map((cat) => (
        <Row simple key={cat.uuid}>
          <Item area="icon">
            <ColorIcon color={cat.metadata.color} size={40} />
          </Item>

          <Item area="name" justifyContent="center">
            <Body small>{cat.name}</Body>
            {cat.tag && <StyledLabel color={colors.greys.mediumDark}>{cat.tag.name}</StyledLabel>}
          </Item>

          <Item area="amount" justifyContent="center" alignItems="flex-end">
            <Body>
              <FormattedNumber value={cat.amount / 100} />
            </Body>
          </Item>
        </Row>
      ))}
    </Flex>
  )
}
